import React,{useState} from 'react'
import './Footer.css'
import logo1 from '../../img/Image-1.png'
import logo2 from '../../img/Image.png'

const Footer = () => {
    const [newsletter, setNewsLetter] = useState('')
  return (
    <div className="footer">
        <div className="footer-first">
            <div className="logo-container-footer">
            <img src={logo1} alt="" />
                <img src={logo2} alt="" />
            </div>
            <h4>Hishabee Technologies Limited</h4>
            <p>Contact: +8809638011199</p>
        </div>
        <div className="footer-second">
            <h4>Useful Links</h4>
            <ul>
                <li>Privacy Policy</li>
                <li>Terms of Use</li>
                <li>Tutorials</li>
                <li>Feedback & Sugesstion</li>
                <li>Contact Us</li>
            </ul>
        </div>
        <div className="footer-third">
            <h4>Follow Us</h4>
            <ul>
                <li>Facebook</li>
                <li>Instagram</li>
                <li>Linked In</li>
            </ul>
        </div>
        <div className="footer-fourth">
            <h4>Newsletter</h4>
            <form>
                <input type="text" value={newsletter} onChange={e=>setNewsLetter(e.target.value)} />
                <button>Subscribe</button>
            </form>
        </div>
    </div>
  )
}

export default Footer